/**
 * Three-state theme toggle — cycles light → dark → system.
 *
 * Shown in the top nav of each Studio page. Styled to match
 * MerchantMenu so the two sit side-by-side without visual drift.
 *
 * The icon + title reflect the *current* mode so the merchant can see
 * at a glance whether they're pinned to light/dark or following OS
 * prefs. Clicking advances to the next state in the cycle.
 */
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme, type ThemeMode } from "../lib/theme";

const LABEL: Record<ThemeMode, string> = {
  light: "Light mode — click for dark",
  dark: "Dark mode — click to follow OS",
  system: "Following OS — click for light",
};

export function ThemeToggle() {
  const { mode, cycle } = useTheme();
  const Icon = mode === "light" ? Sun : mode === "dark" ? Moon : Monitor;
  return (
    <button
      type="button"
      onClick={cycle}
      title={LABEL[mode]}
      aria-label={LABEL[mode]}
      className="flex items-center justify-center rounded-md border border-neutral-200 dark:border-neutral-700 w-9 h-9 hover:bg-neutral-50 dark:hover:bg-neutral-900"
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}
